export default "__VITE_ASSET__BAbMe7JK__"